import store from '@/store'

/**
 * Check if user is in a list of groups
 * @param {Array} groups Allowed groups
 * @returns {Boolean} User is in group list
 */
export default function (groups) {
  if (!groups.length) {
    return true
  }

  if (groups.includes(store.state.user.meta.group)) {
    return true
  }

  return false
}
